AoPS.Utils.initKeyChain(AoPS, "Contests", "Views");

AoPS.Contests.Views = (function (Views) {
	Views.CPMainView = AoPS.View.extend({
		template_id: "#contest-portal-main-tpl",
		className: "contest-portal-main",
		events: {
			"click .downloadA": "confirmDownloadA",
			"click .downloadB": "confirmDownloadB",
		},
		initialize: function (options) {
			this.render();
			this.listenTo(this.model, "refresh", _.bind(this.render, this));
		},
		constructCrumbs: function () {
			return [
				{
					text:
						this.model.get("contest_crumb_name") ||
						this.model.get("contest_name"),
				},
			];
		},
		render: function () {
			Handlebars.registerHelper(
				"contestIsAMC",
				function (contest_crumb_name, contest_type = "") {
					return contest_crumb_name.includes("amc-" + contest_type);
				}
			);

			this.vars = this.model.export();
			this.vars.special_messages = AoPS.bootstrap_data.special_messages || [];

			if (!this.model.get("master").get("isProduction")) {
				console.log(this.vars);
			}

			this.$el.html(this.model.getCmsTemplate(this.template_id, this.vars));

			Handlebars.registerHelper("isGreaterThan", function (num1, num2) {
				return num1 > num2;
			});

			// events partial
			if (this.model.get("master").get("events") !== undefined) {
				Handlebars.registerPartial(
					"events",
					this.model.get("master").get("events")
				);
			}

			this.$main_inner = this.$(".main-inner");
			this.renderHelper();

			this.$event_banner_div = this.$(".event-banner");
			var event_banners = this.model.addEventBanners(
				AoPS.session.user_id,
				this.vars.contest_id
			);
			if (event_banners) {
				var host_id = this.model.get("master").get("host_id");

				for (var event_banner of event_banners) {
					this.$event_banner_div
						.attr("data-key", event_banner.key)
						.attr("data-contest-id", event_banner.event.get("contest_id"))
						.attr("data-contest-name", event_banner.event.get("contest_name"))
						.attr("data-contest-hash", event_banner.event.get("contest_hash"))
						.attr("data-host-id", host_id)
						.addClass(event_banner.is_practice ? "practice" : "official")
						.append(event_banner.banner);
				}
			}
		},
		renderHelper: function () {},
		renderSubView: function (viewModelName) {
			this.innerView = new Views[viewModelName]({
				model: this.model,
				parent: this,
				root: this,
			});
			this.innerView.$el.appendTo(this.$main_inner.empty());
		},
		confirmDownloadA: function () {
			AoPS.Contests.Utils.CreateModalConfirm(
				$("<div />")
					.css("max-width", "480px")
					.html(this.model.getCmsTemplate("#contest-portal-download")),
				_.bind(function () {
					window.open(
						"http://cdn.artofproblemsolving.com/school/crypt/00301-0c73c4b87027afe833e737ee22eee4251f7ac624/files/2021-Putnam-A.pdf",
						"_blank"
					);
				}, this),
				null,
				{
					confirm_button_ok: "Continue",
					confirm_button_cancel: "Cancel",
				}
			);
		},
		confirmDownloadB: function () {
			AoPS.Contests.Utils.CreateModalConfirm(
				$("<div />")
					.css("max-width", "480px")
					.html(this.model.getCmsTemplate("#contest-portal-download")),
				_.bind(function () {
					window.open(
						"http://cdn.artofproblemsolving.com/school/crypt/00301-0c73c4b87027afe833e737ee22eee4251f7ac624/files/2021-Putnam-B.pdf",
						"_blank"
					);
				}, this),
				null,
				{
					confirm_button_ok: "Continue",
					confirm_button_cancel: "Cancel",
				}
			);
		},
	});

	Views.ContestPortalRegistration = Views.CPMainView.extend({
		renderHelper: function () {
			if (!AoPS.session.logged_in) {
				this.renderSubView("ContestPortalLoggedOut");
			} else if (!(this.vars.portal_user || {}).portal_user_id) {
				this.renderSubView("ContestPortalUnauthorized");
			} else if ((this.vars.portal_user || {}).require_account_upgrade) {
				this.renderSubView("ContestPortalRequireAccountUpgrade");
			} else if (this.vars.window.official_registration_can_access) {
				if (this.vars.portal_registration_form) {
					this.renderSubView("ContestPortalRegistrationMain");
				} else {
					this.$main_inner.html("Loading...");
					this.model.updatePortalUserData(
						{},
						_.bind(function () {
							Backbone.history.navigate(this.vars.contest_portal_route, {
								trigger: true,
							});
						}, this)
					);
				}
			} else if (this.vars.window.official_registration_has_ended) {
				this.renderSubView("ContestPortalRegistrationEnded");
			} else {
				this.renderSubView("ContestPortalRegistrationNotStarted");
			}
		},
	});

	Views.ContestPortalRoot = Views.CPMainView.extend({
		renderHelper: function () {
			if (!AoPS.session.logged_in) {
				this.renderSubView("ContestPortalLoggedOut");
			} else if (this.model.get("master").get("is_coach")) {
				if (!(this.vars.portal_user || {}).portal_user_id) {
					this.renderSubView("ContestPortalUnauthorized");
				} else {
					this.renderSubView("ContestPortalCoachMain");
				}
			} else {
				if (
					!this.vars.children.length &&
					(!this.vars.standalone || this.vars.portal_registration_form === null)
				) {
					this.renderSubView("ContestPortalUnauthorized");
				} else {
					this.renderSubView("ContestPortalStudentMain");
					AoPS.Contests.Utils.setupEventBanner(this.vars.terms);
				}
			}
		},
	});

	Views.CPGenericSubView = AoPS.View.extend({
		initialize: function (options) {
			this.parent = options.parent;
			this.root = options.root;
			this.options = options;
			this.render();
		},
		prerenderHelper: function () {
			this.vars = _.extend({}, this.parent.vars);
		},
		render: function () {
			this.prerenderHelper();
			if (this.model.get("master").get("faqs_partial") !== undefined) {
				Handlebars.registerPartial(
					"faqs_partial",
					this.model.get("master").get("faqs_partial")
				);
			}
			this.$el.html(this.model.getCmsTemplate(this.template_id, this.vars));
			this.renderHelper();

			var $test_dropzone = this.$("#test-dropzone");
			if ($test_dropzone && $test_dropzone.data("problem-flavor")) {
				this.model.getProblemType(
					$test_dropzone.data("problem-flavor"),
					_.bind(this.renderTestDropzone, this)
				);
			}
		},
		renderHelper: function () {},
		renderTestDropzone: function (format_data) {
			this.$("#test-dropzone").html(
				this.getTemplate("#contests-tpl-dropzone", {
					title: "Test Contest Submission PDF Upload",
					id: "test",
					no_file_msg: format_data.no_file_msg,
					with_file_msg: format_data.with_file_msg,
				})
			);

			// just grab any random registration
			var registration_id, contest_id;
			for (var registration of Object.values(
				this.model.get("master").get("registrations")
			)) {
				registration_id = registration.contest_registration_id || null;
				contest_id = registration.contest_id || null;
				if (registration_id && contest_id) {
					break;
				}
			}
			if (!registration_id || !contest_id) {
				return;
			}
			this.$("#droptest.dropzone").dropzone({
				url: "/m/contests/dropzone_example_upload.php",
				accept: function (file, done) {
					if (this.currentFile && format_data.max_files === 1) {
						this.removeFile(this.currentFile);
						this.currentFile = false;
					}
					var ext = file.name.split(".").pop().toLowerCase();
					if (_.indexOf(format_data.allowed_files, ext) < 0) {
						done(
							"Error! Files of this type are not accepted. Allowed types are: " +
								format_data.allowed_files.join(", ") +
								"."
						);
					}
					done();
					$(window).trigger("resize");
				},
				sending: function (file, xhr, formData) {
					formData.append("contest_id", contest_id);
					formData.append("registration_id", registration_id);
					$(window).trigger("resize");
				},
				removedfile: function (file) {
					if (
						_.isObject(file.previewElement) &&
						_.isObject(file.previewElement.parentNode)
					) {
						file.previewElement.parentNode.removeChild(file.previewElement);
					}
					$(window).trigger("resize");
					return this._updateMaxFilesReachedClass();
				},
				maxFilesize: format_data.max_filesize,
				maxFiles: format_data.max_files === 1 ? 2 : format_data.max_files,
				success: function (file, response) {
					var data = JSON.parse(response);
					if (data.error_code) {
						AoPS.Ui.Modal.showAlert(data.error_msg);
						this.removeFile(file);
						this.currentFile = false;
					} else {
						this.currentFile = file;
						var submission = data.response;
						if (submission) {
							self
								.$("#problem-test-submission")
								.html(
									'<i class="fas fa-check-circle" style="color: darkgreen;"></i>Your Submission: <a href="' +
										data.response.file_path +
										'" target="_blank">' +
										data.response.pretty_file_name +
										"</a>"
								);
						}
						$(file.previewElement).addClass("dz-success");
					}
					$(window).trigger("resize");
				},
				error: function (file, error) {
					if (error.substr(0, 15) === "File is too big") {
						AoPS.Ui.Modal.showAlert(
							"Your file is too large. You may only upload files up to 2 MB."
						);
					} else {
						AoPS.Ui.Modal.showAlert(error);
					}
					this.removeFile(file);
					$(window).trigger("resize");
				},
			});
		},
		getTemplateVariables() {
			return _.extend(this.vars, this.model.export());
		},
		filterFAQs: function (type) {
			var faqs = this.model.get("master").get("faqs");
			this.vars.faqs = _.filter(faqs, function (faq) {
				return faq.types && faq.types.includes(type);
			});
		},
		events: {
			"click .btn.sign-in": "showSignInModal",
			"click .btn.sign-out": "signOut",
			"click .register": "showRegisterModal",
			"submit form": "onFormSubmit",
			"click form input[type='cancel']": "onFormCancel",
			"click .btn.edit-registration": "onEditRegistration",
			"click .invitation-link": "selfHighlight",
		},
		selfHighlight: function (e) {
			$(e.target).select();
		},
		showSignInModal: function (e) {
			AoPS.login.display();
		},
		signOut: function (e) {
			AoPS.login.logout(e);
		},
		showRegisterModal: function (e) {
			AoPS.Register.display();
		},
		onFormSubmit: function (e) {},
		onFormCancel: function (e) {},
		onEditRegistration: function (e) {},
	});

	Views.ContestPortalUnauthorized = Views.CPGenericSubView.extend({
		template_id: "#contest-portal-unauthorized-tpl",
	});

	Views.ContestPortalLoggedOut = Views.CPGenericSubView.extend({
		template_id: "#contest-portal-logged-out-tpl",
	});

	Views.ContestPortalRegistrationNotStarted = Views.CPGenericSubView.extend({
		template_id: "#contest-portal-registration-not-started-tpl",
	});

	Views.ContestPortalRegistrationEnded = Views.CPGenericSubView.extend({
		template_id: "#contest-portal-registration-ended-tpl",
	});

	Views.ContestPortalRegistrationMain = Views.CPGenericSubView.extend({
		template_id: "#contest-portal-registration-main-tpl",
		events: {
			"click .tooltip": "displayTooltip",
			"submit form": "onFormSubmit",
			"click form input[type='cancel']": "onFormCancel",
		},
		renderHelper: function () {
			_.each(this.$(".radio-style label.has-dependent"), function (label) {
				var $label = $(label);
				var $radio = $label.find("input[type='radio']");
				var $dependent = $label.find("input.is-dependent");
				$label.click(function () {
					$dependent.focus();
				});
				$dependent.focus(function () {
					$radio.prop("checked", true);
				});
			});
		},
		onFormSubmit: function (e) {
			var formOutput = _.reduce(
				this.$("form").serializeArray(),
				function (object, item) {
					object[item.name] = (item.value || "").trim();
					return object;
				},
				{}
			);
			this.model.validateAndUpdatePortalUserData(
				formOutput,
				_.bind(function () {
					Backbone.history.navigate(this.vars.contest_portal_route, {
						trigger: true,
					});
					if (this.vars.portal_user) {
						var template_id =
							"#contest-portal-registration-modal-" +
							(this.vars.portal_user.registered_at ? "edit-" : "new-") +
							this.vars.portal_user.user_type +
							"-tpl";
						var template_output = this.model.getCmsTemplate(
							template_id,
							this.vars
						);
						if (template_output) {
							AoPS.Contests.Utils.CreateModalAlert(
								$("<div />").css("max-width", "480px").html(template_output),
								function () {
									location.reload();
								}
							);
						}
					}
					$("html, body").animate({scrollTop: 0}, "fast");
				}, this)
			);
			e.preventDefault();
		},
		onFormCancel: function (e) {
			AoPS.Contests.Utils.CreateModalConfirm(
				$("<div />")
					.css("max-width", "480px")
					.text(
						"Are you sure that you want to cancel & return to the previous screen? You will lose any unsaved changes."
					),
				_.bind(function () {
					Backbone.history.navigate(this.vars.contest_portal_route, {
						trigger: true,
					});
				}, this),
				null,
				{
					confirm_button_ok: "YES",
					confirm_button_cancel: "NO",
				}
			);
			e.preventDefault();
		},
		displayTooltip: function (e) {
			var tooltipText = e.target.getAttribute("tooltip");
			AoPS.Ui.Modal.showAlert(tooltipText);
		},
	});

	return Views;
})(AoPS.Contests.Views || {});
